/**
 * Sort entries by rawDate field in ascending order
 *
 * @param entries - Array of entries with rawDate property
 * @returns Sorted array of entries
 *
 * @example
 * sortEntriesByRawDate(dailyEntries)
 */
export const sortEntriesByRawDate = <T extends { rawDate: string }>(entries: T[]): T[] => {
  return [...entries].sort((a, b) => a.rawDate.localeCompare(b.rawDate));
};
